import { getCountry, getManualByCountry } from '../utils';

const country = getCountry();
const docHost = `http://localhost:4321`;
const linkManual = getManualByCountry(country, docHost);

export const env = {
    NODE_ENV: 'development',
    NEOGIG_CLIENT_ID: 'neogig_local',
    NEODASH_CLIENT_ID: 'neodash_local',
    MAPBOX_KEY: `pk.eyJ1IjoibmVvY29tc2VydmljZSIsImEiOiJjbWRodGl3ZjkwNWd5MmpxMXMzM2RubWlxIn0.cVfKHNfwS3HgtJn4rj1vPg`,
    GOOGLE_MAPS_API_KEY: 'AIzaSyCA0PnZss05UqLCBCHW11hK1FLULtrfYO0',
    CARTO_KEY: 'cb1_28bg_1_0356ced9998003b244e01e82',
    URL: {
        NEOGIG_HOST: 'http://localhost:3000',
        NEODASH_HOST: 'http://localhost:4200',
        API_HOST: `http://localhost:5000/api/v1`,
        MANUAL_URL: linkManual,
        IDENTITY_SERVER_URL: `https://identity-server.qa.neogig.com.br`,
        CTRL_PANEL_API: `https://cp-api.qa.neogig.com.br`
    }
};



// WEBPACK FOOTER //
// ./src/config/local.env.js